import { BaseDto, DtoId } from '@/shared/lib/sj-orm/models/base.dto';

export interface QuestionDto extends BaseDto {
  groupId: DtoId;

  label: string;
  type: QuestionType;
  required?: boolean;

  expression?: QuestionExpressionType;
}

export enum QuestionType {
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  TEXT_MULTILINE = 'TEXT_MULTILINE',

  CHECKBOX = 'CHECKBOX',
  RADIO_BUTTON = 'RADIO_BUTTON',
  EMAIL = 'EMAIL',
  DATE_TIME = 'DATE_TIME',
  DATE = 'DATE',
  TIME_DURATION = 'TIME_DURATION',
  SELECT_FROM_LIST = 'SELECT_FROM_LIST',
  PICK_ARRAY_OF_DTO = 'PICK_ARRAY_OF_DTO',
  PICK_ONE_OF_DTOS = 'PICK_ONE_OF_DTOS',
  SELECT_PID_BENEFICIARY = 'SELECT_PID_BENEFICIARY',

  PHONE_NUMBER = 'PHONE_NUMBER',
  CURRENCY_CALCULATOR = 'CURRENCY_CALCULATOR',
  CURRENCY_AMOUNT = 'CURRENCY_AMOUNT',
  URL = 'URL',
  FILE_UPLOAD = 'FILE_UPLOAD',

  // TODO: remove after moving all legacy forms to useFormRenderV2
  RENDER_NEW_BUTTON = 'RENDER_NEW_BUTTON',

  ASSET_MARKET_VALUE_CALCULATOR = 'ASSET_MARKET_VALUE_CALCULATOR',
  ADDRESS = 'ADDRESS',
  CO_OWNERS = 'CO_OWNERS',
  LEGALIZED_COPIES = 'LEGALIZED_COPIES',
}

//expressions

export type QuestionExpressionType =
  | {
      relevanceType: RelevanceEnum.AND | RelevanceEnum.OR;
      value: QuestionExpressionValue[];
    }
  | {
      relevanceType: RelevanceEnum.ALONE;
      value: QuestionExpressionValue;
    };

export type QuestionExpressionValue = { relevanceId: DtoId } & (
  | {
      type:
        | QuestionExpressionEnum.LENGTH_LESS
        | QuestionExpressionEnum.LENGTH_EQUAL
        | QuestionExpressionEnum.LENGTH_MORE
        | QuestionExpressionEnum.NUMBER;
      compareData: number;
    }
  | {
      type: QuestionExpressionEnum.TEXT;
      compareData: string;
    }
  | {
      type: QuestionExpressionEnum.YES_NO;
      compareData: boolean;
    }
);

export enum QuestionExpressionEnum {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  LENGTH_MORE = 'LENGTH_MORE',
  LENGTH_LESS = 'LENGTH_LESS',
  LENGTH_EQUAL = 'LENGTH_EQUAL',
  YES_NO = 'YES_NO',
}

export enum RelevanceEnum {
  AND = 'AND',
  OR = 'OR',
  ALONE = 'ALONE',
}
